import angular from 'angular';
import moment from 'moment';

(function() {
    'use strict';
    angular.module('app.core').factory('ReportFilter', ReportFilterData);

    ReportFilterData.$inject = ['REPORTS'];

    /* @ngInject */
    function ReportFilterData(REPORTS) {
        ReportFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch,
            setPage: setPage,
            setPageSize: setPageSize,
            setSort: setSort,
            resetSort: resetSort
        };

        function ReportFilter(reportFilterData) {
            if (!reportFilterData) {
                this.buildEmpty();
            } else {
                this.build(reportFilterData);
            }
        }

        return ReportFilter;

        /////////////////////

        function buildEmpty() {
            this.dateFrom = new Date();
            this.dateTo = new Date();
            this.types = ['ALL'];
            this.checkParam2 = true;
            this.pageCriteria = {
                pageSize: REPORTS.reports.pagination.defaultPageSize,
                page: REPORTS.reports.pagination.defaultPage,
                sorts: REPORTS.reports.pagination.defaultSort
            };
        }

        function build(reportFilterData) {
            this.dateFrom = reportFilterData.dateFrom || new Date();
            this.dateTo = reportFilterData.dateTo || new Date();
            this.types = reportFilterData.types || ['ALL'];
            this.checkParam2 = true;
            this.pageCriteria = {
                pageSize: reportFilterData.pageSize || REPORTS.reports.pagination.defaultPageSize,
                page: reportFilterData.page || REPORTS.reports.pagination.defaultPage,
                sorts: _setSort(reportFilterData.sorts)
            };
        }

        function _setSort(sorts) {
            if (!sorts || sorts.length === 0) {
                return REPORTS.reports.pagination.defaultSort;
            }
            return sorts;
        }

        function preparBeforeSearch() {
            var clone = new ReportFilter(this);
            clone.pageCriteria = this.pageCriteria;
            if (clone.types.indexOf('ALL') === 0) {
                clone.types = REPORTS.reports.types.slice();
                clone.types.splice(0, 1);
            }
            clone.dateFrom = this.dateFrom
                ? moment(this.dateFrom)
                      .startOf('day')
                      .toDate()
                : null;
            clone.dateTo = this.dateTo
                ? moment(this.dateTo)
                      .endOf('day')
                      .toDate()
                : null;
            return clone;
        }

        /**
         * Indiquer la page
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Mise à jour du tri (tri sur une seule colonne)
         */
        function setSort(sorts) {
            this.pageCriteria.sorts = sorts;
        }

        /**
         * Lorsqu'on ne souhaite aucun tri
         */
        function resetSort() {
            this.pageCriteria.sorts = [];
        }
    }
})();
